import styled from 'styled-components';


const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
`;

const TitleLayout = styled.div``;

const Title = styled.div`
	font-size: 14px;
	font-weight: 500;
	text-transform: uppercase;
	margin-bottom: 10px;
`;

const TitleInfoLayout = styled.div`
	display: flex;
	align-items: center;
`;

const TitleBankLayout = styled.div`
	display: flex;
	align-items: center;
`;

const TitleBankIconLayout = styled.div`
	display: flex;
	align-items: center;
	margin-right: 10px;
`;

const TitleBankName = styled.div`
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
`;

const TitleLinkLayout = styled.div`
	font-size: 12px;
	text-transform: none;
	font-weight: 400;
`;

const SubmitButtonLayout = styled.div`
	margin-top: 30px;
`;

export {
	Root,
	TitleLayout,
	Title,
	TitleInfoLayout,
	TitleBankLayout,
	TitleBankIconLayout,
	TitleBankName,
	TitleLinkLayout,
	SubmitButtonLayout,
};
